import { useContext } from 'react';
import { UINavContext, UINavContextData } from './context';

export function useUINav(): UINavContextData {
    const data = useContext<UINavContextData | undefined>(UINavContext);

    if (!data) {
        throw new Error(
            "UINavContext unavailable. Are you sure you're using this in a nested component of an UINavProvider?"
        );
    }

    return data;
}
